exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wordWrap[data-v-3433b4f1]{word-wrap:break-word;white-space:-moz-pre-wrap;white-space:pre-wrap;text-align:left;font-size:30px}", ""]);

// exports
